import { httpGet, httpPost, httpPut } from "@/request/http";

let path = "/monthly-cost-closes";

export default {
  getRange() {
    return httpGet(`${path}/search/range`);
  },
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  getValidRange() {
    return httpGet(`${path}/valid/range`);
  },
  getLogs(year, month) {
    return httpGet(`${path}/${year}/${month}/logs`);
  },
  save(item) {
    return httpPost(path, item); // { Year: 2026, Month: 5 }
  },
  reOpen(item) {
    return httpPut(`${path}/reopen`, item); // { Year: 2026, Month: 5 }
  },
};
